import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackClickedViewKeyImages.meta';

export type UseTrackClickedViewKeyImagesParams = {
  person_id: string;
  location: 'named-people-page' | 'unnamed-people-page' | 'person-page-menu' | 'people-settings';
};

export const useTrackClickedViewKeyImages = () => {
  const { track } = useAnalyticsUtilities();

  const trackClickedViewKeyImages = useCallback(
    (params: UseTrackClickedViewKeyImagesParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackClickedViewKeyImages };
};
